/**
 * Newsdiffs result page: loads the version history partial, then lets the user
 * pick the two revisions to compare. Side 1 cannot select a revision at or
 * before the one chosen on side 0, so those options are disabled on each pick.
 */
function selectorFor(side, groupSide) {
    return `.diffs-select[data-side="${side}"][data-group-side="${groupSide}"]`;
}

function createRevisionPicker() {
    const current = [];

    function readInitialSelection() {
        [0, 1].forEach((side) => {
            const element = document.querySelector(`.diffs-select[data-side="${side}"]`);

            if (element) {
                current[side] = element.dataset.groupSide;
            }
        });
    }

    function disableInvalidRightHandOptions() {
        const leftElement = document.querySelector(selectorFor(0, current[0]));
        const leftIndex = leftElement ? parseInt(leftElement.dataset.index, 10) : 0;
        const rightOptions = document.querySelectorAll('.diffs-select[data-side="1"]');

        rightOptions.forEach((element) => element.classList.remove('disabled'));

        rightOptions.forEach((element) => {
            if (parseInt(element.dataset.index, 10) < leftIndex) {
                return;
            }

            if (element.classList.contains('active')) {
                const previous = document.querySelector(`.diffs-select[data-side="1"][data-index="${leftIndex - 1}"]`);

                if (previous) {
                    current[1] = previous.dataset.groupSide;
                }
            }

            element.classList.add('disabled');
        });
    }

    function renderActiveGroup() {
        document.querySelectorAll('.match-group').forEach((element) => {
            element.classList.remove('active');
        });

        document.querySelectorAll(`.match-group[data-group="${current[0]}-${current[1]}"]`).forEach((element) => {
            element.classList.add('active');
        });

        document.querySelectorAll('.diffs-select').forEach((element) => {
            element.classList.remove('active');
        });

        document.querySelector(selectorFor(0, current[0]))?.classList.add('active');
        document.querySelector(selectorFor(1, current[1]))?.classList.add('active');
    }

    function handleClick(event) {
        const select = event.target.closest('.diffs-select');

        if (!select || select.classList.contains('disabled')) {
            return;
        }

        current[parseInt(select.dataset.side, 10)] = select.dataset.groupSide;

        disableInvalidRightHandOptions();
        renderActiveGroup();
    }

    return { readInitialSelection, handleClick };
}

function renderFetchError(resultsSegment, data) {
    const errors = data?.errors ?? [];

    const message = errors.length > 0
        ? errors.map((error) => `<p>${error.error}</p>`).join('')
        : '<p>Unable to retrieve article versions at this time.</p>';

    resultsSegment.innerHTML = '<div class="row">'
        + '<div class="col-lg-12">'
        + '<div class="col-lg-12 col-purple-dark text-center">'
        + '<h3>Error!</h3>'
        + message
        + '</div></div></div>';
}

function initNewsdiffsResult() {
    const resultsSegment = document.getElementById('results_segment');

    if (!resultsSegment) {
        return;
    }

    const picker = createRevisionPicker();

    document.body.addEventListener('click', picker.handleClick);

    fetch(resultsSegment.dataset.fetchUrl)
        .then((response) => {
            if (!response.ok) {
                return response.json().then((data) => Promise.reject(data));
            }

            return response.text();
        })
        .then((html) => {
            resultsSegment.innerHTML = html;
            picker.readInitialSelection();
        })
        .catch((data) => {
            renderFetchError(resultsSegment, data);
        });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsdiffsResult);
} else {
    initNewsdiffsResult();
}
